import { IOption } from '@websolutespa/bom-core';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

export type DownloadModalPayload = {
  fileId?: string;
};

interface DownloadModalContextValue {
  isOpen: boolean;
  payload: DownloadModalPayload;
  countries: IOption[];
  provinces: IOption[];
  openDownloadModal: (payload?: DownloadModalPayload) => void;
  closeDownloadModal: () => void;
}

const DownloadModalContext = createContext<
  DownloadModalContextValue | undefined
>(undefined);

export const DownloadModalProvider = ({
  children,
  countries = [],
  provinces = [],
}: {
  children: ReactNode;
  countries?: IOption[];
  provinces?: IOption[];
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [payload, setPayload] = useState<DownloadModalPayload>({});

  const openDownloadModal = useCallback(
    (newPayload: DownloadModalPayload = {}) => {
      setPayload(newPayload);
      setIsOpen(true);
    },
    []
  );

  const closeDownloadModal = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => setPayload({}), 300);
  }, []);

  const value: DownloadModalContextValue = {
    isOpen,
    payload,
    countries,
    provinces,
    openDownloadModal,
    closeDownloadModal,
  };

  return (
    <DownloadModalContext.Provider value={value}>
      {children}
    </DownloadModalContext.Provider>
  );
};

export const useDownloadModal = () => {
  const context = useContext(DownloadModalContext);
  if (context === undefined) {
    throw new Error(
      'useDownloadModal must be used within a DownloadModalProvider'
    );
  }
  return context;
};
